/* @flow */
import moment from 'moment';
import * as React from 'react';

import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import Dialog from 'components/Dialog';
import Divider from 'components/Divider';
import EventTracking from 'lib/EventTracking';
import Heading from 'components/Heading';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';
import UserAvatar from 'users/components/UserAvatar';

import './styles/FilesTable.scss';

type Props = {
  file: *,
  filesEventFields: Function,
  onRequestHide: Function,
};

class FilesTablePreviewDialog extends React.Component<Props> {
  render() {
    const { file, filesEventFields } = this.props;

    const previewImageStyle = {
      backgroundImage: 'url(' + file.filePreviewUrl + ')',
    };
    return (
      <Dialog
        className="FilesDialog"
        eventKey="files.file_details.view"
        eventProperties={{
          ...filesEventFields(file),
        }}
        onRequestHide={() => {
          EventTracking.trackKey('files.file_details.close.click', {
            ...filesEventFields(file),
          });
          this.props.onRequestHide();
        }}>
        <div className="FilesDialog-previewImage" style={previewImageStyle} />
        <BoxBody divided className="FilesDialog-boxBody">
          <Text align="left" element="div">
            <MediaObject center figure="right">
              <div>
                <Link
                  href={file.fileUrl}
                  target="_blank"
                  eventKey="files.file_details.preview.click"
                  eventProperties={{
                    ...filesEventFields(file),
                  }}>
                  <Text color="pitch" size="small" truncate weight="normal">
                    {file.fileName}
                  </Text>
                </Link>
                <Text color="thunder" size="xxsmall">
                  {file.fileNote}
                </Text>
              </div>
              <div>
                <Button
                  className="previewOpenButton"
                  target="_blank"
                  href={file.fileUrl}
                  eventKey="files.file_details.open.click"
                  eventProperties={{
                    ...filesEventFields(file),
                  }}>
                  Open
                </Button>
                {/* Add back in for files V2
              <Button className="previewMoreButton" level="button" color="polar-bear">
                <Glyph solo="true " color="koala" name="ellipses" size="medium" />
              </Button>
              */}
              </div>
            </MediaObject>
            <Divider size="medium" />
            <Row>
              <Heading level="3">Message</Heading>
              <Text className="FilesDialog-text" color="pitch" size="small" weight="normal">
                {file.fileBody}
              </Text>
            </Row>
            <Row>
              <Heading level="3">Shared on</Heading>
              <div>{moment(file.fileCreatedAt).format('MMMM D YYYY, [at] h:mm a')}</div>
            </Row>
            <section>
              <Heading level="3">Shared by</Heading>
              <MediaObject center gutter="small">
                <UserAvatar
                  user={{
                    initials: file.fileSenderInitials,
                    profilePictureUrl: file.fileSenderAvatarUrl,
                  }}
                  size="large"
                  className="previewAvatar"
                />
                <div>{file.fileSenderName}</div>
              </MediaObject>
            </section>
          </Text>
        </BoxBody>
      </Dialog>
    );
  }
}

export default FilesTablePreviewDialog;
